export class BomWithCountAndQuantityModel {
    soNumber:string;
    variantCode:string;
    count:number;
    quantity:number;
    hlCount?:number;

    constructor(soNumber:string,variantCode:string,count:number,quantity:number,hlCount?:number){
        this.soNumber = soNumber;
        this.variantCode = variantCode;
        this.count = count;
        this.quantity = quantity;
        this.hlCount = hlCount;
    }
}